import { useStartNewChat } from 'hooks/useStartNewChat';
import React from 'react';
import style from './startchatbutton.module.scss';
// import useInitialiseApp from 'hooks/useInitialiseApp';
import useApp from 'hooks/useApp';

interface Props { }

const StartChatButton: React.FC<Props> = props => {

    const startNewChat = useStartNewChat();
    const { language, appTextTranslations } = useApp();
    const startNewChatText = appTextTranslations?.startNewChat?.[language] ?? 'Start a new chat';

    return (
        <div className={style.container}>
            <button className={style.startChatButton} onClick={startNewChat}>
                {startNewChatText}
            </button>
        </div>
    );
};

export default StartChatButton;